module.exports = __webpack_public_path__ + "img/Mask Group down(1).856a7577.svg";